import React from 'react';
import { useFormField } from '../../core';
import { DateSelector } from '@/ui-kit';
import { usePreFilledFieldValidation } from '../../hooks';

type InputDateProps = {
  label: string;
  name: string;
  placeholder?: string;
  warning?: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [x: string]: any;
};

export const InputDate: React.FC<InputDateProps> = ({
  label,
  placeholder,
  warning,
  ...props
}) => {
  const [field, meta] = useFormField(props);

  const { onChange, ...fieldProps } = field;

  const error = meta.touched ? meta.error : undefined;

  usePreFilledFieldValidation(field, meta.touched);

  return (
    <DateSelector
      label={label}
      placeholderText={placeholder}
      onInputChange={onChange}
      {...fieldProps}
      {...props}
      value={field.value as string | undefined}
      state={error ? 'error' : warning ? 'warning' : 'default'}
      stateText={error}
    />
  );
};
